/**
 * Escapes the five HTML-significant characters so untrusted text renders as
 * inert content in both element and attribute (single- or double-quoted) contexts.
 * Unlike the three legacy copies this replaces, it also neutralises the single quote.
 */
export function escapeHtml(value: string): string {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
